export default __webpack_public_path__ + "static/media/grab-rentals-desktop.c1ec0606.png";